module.exports = __webpack_public_path__ + "components/advertise-header/static/c__card--3@2-fd38546819c66b9182ae6f29738e2739.jpg";